import React from 'react'
import {LocaleContext} from '../components/LocalizationProvider'
import {LocalizationData} from '../types'

const useLocalization = (): LocalizationData => React.useContext(LocaleContext)

export default useLocalization
